import { useSelector } from 'react-redux';
import { filter } from 'lodash-es';

import { DomainDetail } from '@dev/ee-api/ee-api-models';
import { getDomainsStore } from '@/store/domain/actions';
import { isDomainVerified, isOwnDomain } from '../helpers';

export const useGetVerifiedDomains = (): DomainDetail[] => {
    const { domains } = useSelector(getDomainsStore);
    return filter(domains, (domain) => isDomainVerified(domain) && isOwnDomain(domain));
};
